module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper short-contents"
  }, [_c('header', {
    staticClass: "gheader -white"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "container bg01 txtC moral-message short-contents"
  }, [_c('div', {
    staticClass: "moral-message__sec01"
  }, [_c('h2', {
    staticClass: "fz18 bold mb15 brown"
  }, [_vm._v("送信しました！")]), _c('p', {
    staticClass: "mb15 fz13"
  }, [_vm._v("ありがとうだニャン！")]), _vm._m(0), _c('p', {
    staticClass: "btn-link"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('span', [_vm._v("トップページへ戻る")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moral-message__sec01__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_05.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2952de4b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/message-sent-manager.pug
// module id = 1400
// module chunks = 1